var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAvatar = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.17383C7.1868 2.17383 4.90625 4.45438 4.90625 7.26758C4.90625 10.0808 7.1868 12.3613 10 12.3613C12.8132 12.3613 15.0938 10.0808 15.0938 7.26758C15.0938 4.45438 12.8132 2.17383 10 2.17383ZM2.90625 7.26758C2.90625 3.34981 6.08223 0.173828 10 0.173828C13.9178 0.173828 17.0938 3.34981 17.0938 7.26758C17.0938 11.1853 13.9178 14.3613 10 14.3613C6.08223 14.3613 2.90625 11.1853 2.90625 7.26758Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 14.3613C8.50558 14.3613 7.03318 14.721 5.70703 15.4099C4.38088 16.0988 3.24 17.0968 2.38077 18.3195C2.06322 18.7714 1.43949 18.8803 0.987625 18.5627C0.535755 18.2452 0.426861 17.6215 0.744403 17.1696C1.78817 15.6843 3.17407 14.472 4.78503 13.6351C6.396 12.7982 8.18463 12.3613 10 12.3613C11.8154 12.3613 13.6042 12.7982 15.2151 13.6351C16.8261 14.472 18.212 15.6843 19.2558 17.1696C19.5733 17.6215 19.4644 18.2452 19.0125 18.5627C18.5607 18.8803 17.9369 18.7714 17.6194 18.3195C16.7602 17.0968 15.6193 16.0988 14.2931 15.4099C12.967 14.721 11.4944 14.3613 10 14.3613Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar.071da74f3c888df79235f300605eb2c5.svg";